// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../pages/HomePage.vue'
import GamesPage from '../pages/GamesPage.vue'
import ProjectsPage from '../pages/ProjectsPage.vue'
import ContactPage from '../pages/ContactPage.vue'
import ExposicoesPage from '../pages/ExposicoesPage.vue'
import ExposicaoDetailPage from '../pages/ExposicaoDetailPage.vue'
import CvPage from '../pages/CvPage.vue'
const routes = [
  { path: '/',               component: HomePage,           meta: { title: 'Home' } },
  { path: '/games',          component: GamesPage,          meta: { title: 'Games' } },
  { path: '/projects',       component: ProjectsPage,       meta: { title: 'Projects' } },
  { path: '/contact',        component: ContactPage,        meta: { title: 'Contact' } },
  { path: '/cv',             component: CvPage,             meta: { title: 'CV' } },
  { path: '/exposicoes',     component: ExposicoesPage,     meta: { title: 'Exposicoes' } },
  { path: '/exposicoes/:id', component: ExposicaoDetailPage, props: true, meta: { title: 'Exposicao' } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach((to) => {
  const pageTitle = to.meta?.title || 'Home'
  document.title = `${pageTitle} - Gus Machado`
})

export default router
